module.exports = __webpack_public_path__ + "img/xpu-ha-hotel.859d6c13.jpg";